<template>
    <on-click-outside :do="close">
        <form role="search" method="get" ref="qform" action="/en/search">
            <div class="relative py-2">
                <input
                        v-model="query"
                        name="q"
                        class="focus:outline-none p-2 pl-10 rounded bg-grey-lighter w-full focus:bg-white border focus:border-blue-dark"
                        type="search"
                        aria-label="Searchbox"
                        placeholder="Search statistical sources"
                        autocomplete="off"
                        @keydown.up="up"
                        @keydown.down="down"
                        @keydown.right="complete"
                        @keydown.enter.prevent="submit"
                        ref="qfield"
                >
                <div class="absolute pin-y pin-l pl-3 flex items-center text-grey">
                    <i class="fa fa-search"></i>
                </div>
                <div
                        v-show="query.length > 0"
                        @click="reset()"
                        class="cursor-pointer absolute pin-y pin-r pr-3 flex items-center text-grey"
                >
                    <i class="fa fa-times"></i>
                </div>
                <div
                        class="absolute pt-2 w-full z-20"
                        v-if="open"
                >
                    <ul class="list-reset bg-white shadow border rounded">
                        <li
                                v-for="e in result"
                        >
                            <a class="cursor-pointer px-8 py-2 hover:bg-blue-lighter block flex"
                               :class="{'bg-blue-lighter': pos === e.key}"
                               @mouseover="pos = e.key"
                               @click="add(e.item)">
                                <div><i class="text-grey fa fa-fw fa-search mr-4"></i></div>
                                <div>{{ e.item }}</div>
                            </a>
                        </li>
                        <li v-for="item in series">
                            <a
                                    @click="addSeries(item.series)"
                                    class="cursor-pointer pl-8 pr-2 py-2 hover:bg-blue-lighter block flex justify-between flex-nowrap">
                                <div class="flex">
                                    <div><i class="text-grey fa fa-fw fa-list mr-4"></i></div>
                                    <div>{{ item.series.description.en }}</div>
                                </div>
                                <div class="flex flex-nowrap">
                                    <span class="text-sm text-grey mr-2">{{item.series.end | date }}</span>
                                    {{ item.series.latest }}
                                </div>
                            </a>

                        </li>
                    </ul>
                </div>
            </div>
        </form>
    </on-click-outside>
</template>

<script>

    import OnClickOutside from "../OnClickOutside";

    export default {

        components: {OnClickOutside},

        props: {
            q: {
                type: String,
                default: '',
                required: false,
            },
            doSearch: {
                type: Boolean,
                default: true,
                required: false,
            }
        },

        data() {
            return {
                ac: [],
                pos: -1,
                open: false,
                query: this.q,
                seriesResponse: [],
            };
        },

        filters: {
            date(string) {
                return string.substring(0, 4);
            }
        },

        computed: {
            series() {
                let that = this;
                let result = this.seriesResponse.find(function (item) {
                    return item.query === that.query.trim();
                });

                if (result === undefined) {
                    return [];
                }

                return result.series;
            },
            hasResults() {
                return this.ac.length > 0;
            },
            result() {
                return this.ac.map(function (item, key) {
                    return {
                        item: item,
                        key: key
                    };
                })
            }
        },

        watch: {
            query() {
                this.update();
            },
        },

        methods: {
            close() {
                this.open = false;
            },
            update() {
                this.pos = -1;

                if (this.query.length < 1) {
                    this.ac = [];
                    return;
                }

                const that = this;

                // it can happen that a user types "gr"
                // the response for "gr" comes back immediately and is empty
                // but the response for "g" is valid.
                // to implement this we need an API change! return the actual word.
                http.get('/api/v1/indicators/suggest/' + this.query).then((response) => {
                    that.open = true;
                    that.ac = response.data;
                    if (response.data.length === 0) {
                        that.ac = [this.query];
                    }
                });

                http.get('/api/v1/series/search?query=' + this.query).then((response) => {
                    that.seriesResponse.push(response.data);
                });
            },
            down() {
                this.pos++;

                if (this.pos >= this.ac.length) {
                    this.pos = 0;
                }
            },
            up() {
                this.pos--;

                if (this.pos < 0) {
                    this.pos = this.ac.length - 1;
                }
            },
            add(text) {
                this.query = text;
                this.$refs.qfield.focus();
                const that = this;
                Vue.nextTick(function () {
                    that.submit();
                });
            },
            complete() {
                if (this.pos === -1) {
                    return;
                }
                this.query = this.ac[this.pos];
                this.ac = [];
            },
            submit() {
                if (this.pos !== -1) {
                    this.query = this.ac[this.pos];
                }

                this.open = false;

                if (this.doSearch) {
                    Vue.nextTick(() => this.$refs.qform.submit())
                }

                if (!this.doSearch) {
                    this.$emit('search', this.query);
                }
            },
            reset() {
                this.query = "";
                this.open = false;
            },
            addSeries(series) {
                this.$emit('addSeries', series);
                this.reset();
            }
        },
    }
</script>
